import { UntitledIcon } from '@faceup/icons'
import { usXClose } from '@faceup/icons/usXClose'
import { defineMessages, FormattedMessage } from '@faceup/localization'
import { Typography, useUiBaseConfig } from '@faceup/ui-base'
import type { ReactNode } from 'react'

const messages = defineMessages('followUp.pages.page.components.pageNotAvailable', [
  { id: 'disabledTitle', defaultMessage: '' },
  { id: 'disabledDescription', defaultMessage: '' },
] as const)

export const PageNotAvailable = () => (
  <div className='flex flex-col gap-6 items-center justify-center min-h-[60vh]'>
    <CircleIcon icon={<UntitledIcon icon={usXClose} size='40px' color='white' />} />
    <Typography.Title>
      <FormattedMessage message={messages.disabledTitle} />
    </Typography.Title>
    <Typography.Text>
      <FormattedMessage message={messages.disabledDescription} />
    </Typography.Text>
  </div>
)

const CircleIcon = ({ icon }: { icon: ReactNode }) => {
  const { token } = useUiBaseConfig()
  return (
    <div
      className='flex justify-center items-center w-[66px] h-[66px] rounded-full'
      style={{
        background: token.colorPrimary,
      }}
    >
      {icon}
    </div>
  )
}
